/**
 * Gets the site base URL from environment variable or falls back to window.location.origin
 * This ensures proper URLs are used during SSR/pre-rendering and production builds
 */
export const getSiteUrl = (): string => {
  // During react-snap pre-rendering or production build, use the environment variable
  if (process.env.REACT_APP_SITE_URL) {
    return process.env.REACT_APP_SITE_URL;
  }

  // Fallback to window.location.origin for development
  if (typeof window !== "undefined") {
    return window.location.origin;
  }

  // Final fallback (shouldn't normally reach here)
  return "https://domainfindr.com";
};

/**
 * Builds a full URL by combining the site URL with a path
 */
export const buildUrl = (path: string): string => {
  const siteUrl = getSiteUrl();
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${siteUrl}${normalizedPath}`;
};

/**
 * Detects if the app is currently being pre-rendered by react-snap
 */
export const isPrerendering = (): boolean => {
  if (typeof navigator === "undefined") {
    return true;
  }
  return navigator.userAgent === "ReactSnap";
};
